module.exports = __webpack_public_path__ + "img/icn_venue.28132422.svg";